//https://transform.tools/css-to-js

import { createStyles } from 'antd-style';
import list from '../styles/list';
import table from '../styles/table';

export default createStyles((_, props: { isDarkMode: boolean; isPreview?: boolean }) => {
  const { isPreview = !navigator.userAgent.includes('HeadlessChrome') } = props;
  const backgroundColor = props.isDarkMode ? '#000' : '#fff';
  const textColor = props.isDarkMode ? '#f5f5f9' : '#232121';
  const tableBorderColor = props.isDarkMode ? '#f5f5f9' : '#232121';
  const reportBlue = 'rgb(0, 173, 229)';

  return {
    reportStyles: {
      '@page': {
        marginTop: '1in' /* Adjust the margin size as needed */,
        marginBottom: '.75in',
        marginLeft: '.5in',
        marginRight: '.5in'
      },
      '& .report-header': {
        padding: '16px 24px',
        '& .report-title': {
          margin: '4px 12px 4px 0',
          fontWeight: 600,
          fontSize: '20px',
          lineHeight: '32px'
        },
        '& .report-subtitle': {
          margin: '4px 12px 4px 0',
          fontSize: '15px',
          lineHeight: '32px'
        }
      },
      '#report-container': {
        width: '8.5in',
        fontFamily: 'Arial, Helvetica, sans-serif',
        backgroundColor: backgroundColor,
        boxShadow: props.isDarkMode
          ? '0 0 10px 10px rgba(255,255,255,.1)'
          : '0 0 10px 10px rgba(0,0,0,.1)',
        color: textColor,
        fontSize: '9.5pt',
        lineHeight: 1.5715,
        '> .report-section': {
          paddingTop: '1in',
          paddingLeft: '0.5in',
          paddingRight: '0.5in',
          ['boxSizing' as never]: 'border-box'
        },
        '.ck-content, .ant-row, .ant-form, .ant-input, .ant-select-selector, .ant-btn, .ant-table, .ant-form-item-label > label, .label, p, span:not(.anticon)':
          {
            fontSize: '9.5pt'
          },

        '& *:not(.language-plaintext):not(.language-cpp):not(.language-python):not(.language-ruby):not(.language-xml):not(.language-css):not(.language-php):not(.language-diff):not(.language-c):not(.language-cs):not(.language-javascript):not(.language-html)':
          {
            fontFamily: 'Arial, Helvetica, sans-serif'
          },

        ...table(props),
        ...list(props),

        'h1, h2, h3, h4, h5, h6, input.h1, input.h2, input.h3, input.h4': {
          fontWeight: 500,
          lineHeight: '1.2',
          marginBottom: '0',
          marginTop: '1.0rem',
          ['pageBreakAfter' as never]: 'avoid'
        },

        '& .text-uppercase': {
          ['textTransform' as never]: 'uppercase'
        },
        // spacing between header and first item
        'h2 + *, h3 + *, h4 + *, h5 + *, h6 + *': {
          marginTop: '8px !important'
        },
        '& .ck-content h3, & .ck-content h4, & .ck-content h5, & .ck-content h6': {
          marginTop: '1rem'
        },

        'h1, input.h1': {
          ['textTransform' as never]: 'uppercase',
          fontSize: '1.875rem'
        },

        'h2, input.h2': {
          color: reportBlue,
          fontSize: '1.5rem'
        },
        'h3, input.h3': {
          fontSize: '1.3125rem'
        },
        'h4, input.h4': {
          fontSize: '1.125rem'
        },
        'p, table': {
          marginBottom: '0',
          marginTop: '10px',
          // Long URLs in paragraphs
          ['overflowWrap' as never]: 'break-word'
        },

        a: {
          color: '#1890ff',
          textDecoration: 'underline',
          // Long URLs in paragraphs
          ['overflowWrap' as never]: 'break-word',
          // External Links
          ':not(.i-link):not(:empty)': {
            paddingRight: '20px',
            backgroundPosition: 'right',
            backgroundRepeat: 'no-repeat',
            backgroundImage:
              "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='1em' viewBox='0 0 512 512'%3E%3Cpath d='M432,320H400a16,16,0,0,0-16,16V448H64V128H208a16,16,0,0,0,16-16V80a16,16,0,0,0-16-16H48A48,48,0,0,0,0,112V464a48,48,0,0,0,48,48H400a48,48,0,0,0,48-48V336A16,16,0,0,0,432,320ZM488,0h-128c-21.37,0-32.05,25.91-17,41l35.73,35.73L135,320.37a24,24,0,0,0,0,34L157.67,377a24,24,0,0,0,34,0L435.28,133.32,471,169c15,15,41,4.5,41-17V24A24,24,0,0,0,488,0Z'/%3E%3C/svg%3E\")"
          }
        },
        // Make sure that when jumping to section, the section goes below the header
        ':target': {
          display: 'block',
          ['position' as never]: 'relative',
          top: '-150px',
          ['visibility' as never]: 'hidden'
        },
        '& .fontadjust *': {
          fontSize: '1.2rem'
        },

        'div div.row-bordered': {
          borderTop: `2px solid ${tableBorderColor}`,
          borderBottom: `2px solid ${tableBorderColor}`,
          paddingTop: '10px',
          paddingBottom: '10px',
          marginBottom: '10px',
          display: 'table',
          ['tableLayout' as never]: 'fixed',
          width: '100%',
          "> div[class^='col-']": {
            display: 'table-cell',
            verticalAlign: 'middle',
            ['float' as never]: 'none',
            '> h1, h2, h3, h4': {
              display: 'inline-block'
            }
          }
        },

        '& .ta-bordered': {
          borderTop: `2px solid ${tableBorderColor}`,
          borderBottom: `2px solid ${tableBorderColor}`,
          paddingTop: '12px',
          paddingBottom: '12px',
          marginBottom: '10px',
          width: '100%',
          paddingLeft: '5px',
          paddingRight: '5px',
          ['breakInside' as never]: 'avoid',

          '& .title': {
            ['resize' as never]: 'none',
            fontSize: '1.3125rem',
            lineHeight: '1.2',
            fontWeight: 700,
            width: '100%',
            marginLeft: '0',
            paddingBottom: '3px',
            paddingTop: '2px'
          },
          '& .instances': {
            marginTop: '-4px',
            marginBottom: '0',
            padding: '0 8px'
          }
        },

        // Allow no-report-style class to be applied to parent to bypass these styles
        ':not(.no-report-style)': {
          '.ck.ck-content, .ck.ck-editor__editable_inline.ck-content': {
            // This is needed for page breaks inside CKEditor to work in Chrome
            display: 'block !important',
            paddingTop: '0',
            paddingBottom: '0',
            // Make sure no extra space between sections
            '> *:first-child, div[data-id]:first-of-type > :first-child': {
              marginTop: '0 !important'
            },
            '> *:last-child': {
              marginBottom: '0 !important'
            }
          },

          '.ck.ck-content, .ck.ck-editor__editable_inline.ck-content, .ant-input, .ant-input-number':
            {
              ':not(.finding-remediation-recommendation)': {
                // make sure fields don't cover other things
                backgroundColor: 'transparent',
                // Adjust margins so that the content sits inline with the rest of
                // the text in the report
                // this mainly is needed on ck editor items
                marginLeft: '-5px',
                marginRight: '-11px',
                // Remove borders from editors, so that they don't look like editors
                // until user hovers over the field
                borderStyle: 'dashed',

                ':not(:hover):not(:focus)': {
                  borderColor: 'transparent'
                },
                ':hover:not(:focus):not(.ant-input-number-focused)': {
                  borderColor: 'gray'
                },
                ':focus, .ant-input-number-focused': {
                  borderStyle: 'solid'
                }
              }
            },

          '.finding-remediation-recommendation': {
            marginTop: '0px',
            marginBottom: '0px',
            ['breakAfter' as never]: 'auto',
            backgroundColor: 'transparent',
            borderColor: 'transparent',
            padding: '1px',
            minHeight: '35px'
          },

          // Similar operations for the dropdowns
          '.ant-select:not(.ant-select-auto-complete)': {
            '.ant-select-selector': {
              marginLeft: '-5px',
              borderStyle: 'dashed !important',
              width: 'unset',
              ':not(:hover):not(:focus)': {
                borderColor: 'transparent'
              }
            },
            ':not(.ant-select-focused) > .ant-select-selector': {
              borderColor: 'gray'
            },
            '.ant-select-focused > .ant-select-selector': {
              borderStyle: 'solid !important'
            }
          }
        },

        '.ant-form-item-label': {
          paddingBottom: '0'
        }
      },

      '& .report-bottom-padding': {
        height: '100px'
      },
      'tr.drop-over-downward td, div.drop-over-downward': {
        borderBottom: '2px dashed !important'
      },
      'tr.drop-over-upward td, div.drop-over-upward': {
        borderTop: '2px dashed !important'
      },
      'blockquote, code': {
        ['whiteSpace' as never]: 'break-spaces',
        ['lineBreak' as never]: 'anywhere',
        ['overflowWrap' as never]: 'anywhere'
      },
      '.high-priority-remediations': {
        marginBottom: '0.1rem',
        display: 'block'
      },
      '@media screen': {
        margin: '0.5in auto 0.75in auto',
        '#report-container': {
          marginTop: '25px',
          paddingBottom: '1in',
          '> .report-section:first-of-type': {
            paddingTop: '1in'
          },
          '.report-section.page-break:after, .page-break:after': {
            content:
              '"------------------------------------ page break ------------------------------------------"',
            display: 'block',
            opacity: '.3',
            textAlign: 'center',
            margin: '.25in 0 .5in 0'
          }
        }
      },

      '@media print': {
        '.report-header': {
          display: 'none'
        },
        '#report-container': {
          // backgroundColor: 'unset !important',
          // padding: '0',
          // margin: '0 !important',
          boxShadow: 'none !important',
          '> .report-section': {
            padding: 0,
            ['boxSizing' as never]: 'border-box',
            margin: isPreview ? '1in .5in .75in .5in !important' : 0
          },
          '.report-section.page-break': {
            ['breakBefore' as never]: 'page'
          },
          a: {
            color: 'unset',
            textDecoration: 'unset'
          }
        },
        '.section:first-of-type': {
          paddingTop: '0 !important'
        },
        '.page-break:before': {
          display: 'none !important',
          content: "''"
        }
      },
      //...specificCircumstances
      'table .wordBreak td': {
        wordBreak: 'break-all'
      },
      // comments
      '.comment-highlight': {
        backgroundColor: `#ffff0242`,
        padding: '2px 0',
        cursor: 'pointer',
        transition: 'background-color 0.2s ease',
        '&.active': {
          backgroundColor: '#99ff00'
        }
      }
    }
  };
});
